import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a "First Middle Last" name as "Last, First Middle".
 * - Already comma-formatted ("Last, First") is returned as-is.
 * - Single-word names returned as-is.
 * - Empty / null returns an empty string.
 */
export function formatLastFirst(name) {
  const s = (name || "").trim();
  if (!s) return "";
  if (s.includes(",")) return s;
  const parts = s.split(/\s+/);
  if (parts.length < 2) return s;
  const last = parts[parts.length - 1];
  const first = parts.slice(0, -1).join(" ");
  return `${last}, ${first}`;
}
